import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import {
  TextBoxMaxLine1Body4,
  TextBoxMaxLine1Footnote5Secondary,
} from 'atoms/TextBox/Templates'
import { TextBlock } from '../../TextBlock'

export interface ITextBlockDescriptionType1 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockDescriptionType1 = ({
  title,
  description,
  ...rest
}: ITextBlockDescriptionType1): JSX.Element => {
  return (
    <TextBlock {...rest}>
      <TextBoxMaxLine1Footnote5Secondary title={title} />
      <TextBoxMaxLine1Body4 title={description} />
    </TextBlock>
  )
}
